import axios from "axios";
import { Message } from "element-ui";

import store from '@/store'
import router from '@/router'

// 创建 Axios 实例
const service = axios.create({
  // baseURL: "https://hkapi.domidesk.com",
  baseURL: "https://yinheapi.yinheshujie.com/prod-api",
  // baseURL: "http://192.168.2.22:9001",
  // baseURL: "http://47.239.159.228:8080",
  timeout: 30000,
  timeoutErrorMessage: "请求超时！",
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = store.getters.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    
    if (res.code === 401) {
      Message.error("您的登录信息已过期，请重新登录！");
      store.dispatch('ExpireSession');
      location.href = '/login';
      return Promise.reject(new Error("未登录或登录已过期"));
    }

    if (res.code === 600) {
      Message.warning("请完善账户信息");
      router.push({ path: '/user' });
      return Promise.reject(new Error(res.msg || "Error"));
    }

    if (res.code !== 200) {
      !response.config.noTip && Message.error(res.msg || "系统异常");
      return Promise.reject(new Error(res.msg || "Error"));
    }

    return res;
  },
  (error) => {
    // HTTP 层面拦截 401（如果后端直接返回 HTTP 401）
    if (error.response && error.response.status === 401) {
      Message.error("您的登录信息已过期，请重新登录！");
      store.dispatch('ExpireSession');
      location.href = '/login';
    } else {
      Message.error(error.response?.data?.msg || "网络连接失败，请刷新再试！");
    }
    return Promise.reject(error);
  }
);

export default service;
